import { useEffect, useMemo, useRef, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import PdfViewerContainer from "../../../components/PdfViewerContainer";

const SELECT = "SELECT";
const FORM_NAME = "SBISSA3";
const PDF_ENDPOINT = "/FillMyForm/SBISSA3/Print.php";

const girlPersonalFields = [{"name": "faname", "label": "Girl Child Name", "type": "text", "required": true, "maxLength": 36, "alphaOnly": true}, {"name": "fadob", "label": "Girl Child Date of Birth", "type": "date", "required": true}, {"name": "faaadhaarno", "label": "Girl Child Aadhaar Number", "type": "text", "required": true, "maxLength": 12, "numeric": true}, {"name": "fapan", "label": "Girl Child PAN Number", "type": "text", "required": false, "maxLength": 10, "uppercase": true}, {"name": "fafname", "label": "Father's Name", "type": "text", "required": true, "maxLength": 36, "alphaOnly": true}, {"name": "fabcno", "label": "Birth Certificate Number", "type": "text", "required": true, "maxLength": 30}, {"name": "fabcdoi", "label": "Birth Certificate Date of Issue", "type": "date", "required": true}, {"name": "fabcauthority", "label": "Birth Certificate Issuing Authority", "type": "text", "required": true, "maxLength": 35}];
const girlAddressFields = [{"name": "faadd1", "label": "Girl Child Address Line 1", "type": "text", "required": true, "maxLength": 36}, {"name": "faadd2", "label": "Girl Child Address Line 2", "type": "text", "required": true, "maxLength": 36}, {"name": "facity", "label": "Girl Child City", "type": "text", "required": true, "maxLength": 13}, {"name": "fadist", "label": "Girl Child District", "type": "text", "required": true, "maxLength": 23}, {"name": "fastate", "label": "Girl Child State", "type": "text", "required": true, "maxLength": 13}, {"name": "fapin", "label": "Girl Child PIN", "type": "text", "required": true, "maxLength": 6, "numeric": true}, {"name": "fabplace", "label": "Girl Child Birth Place", "type": "text", "required": true, "maxLength": 13}, {"name": "famobile", "label": "Girl Child Mobile", "type": "text", "required": true, "maxLength": 15, "numeric": true}, {"name": "faincome", "label": "Girl Child Income", "type": "text", "required": true, "maxLength": 8, "numeric": true}, {"name": "fareligion", "label": "Girl Child Religion", "type": "select", "required": true, "options": [["HINDU", "HINDU"], ["MUSLIM", "MUSLIM"], ["CHRISTIAN", "CHRISTIAN"], ["SIKH", "SIKH"]]}, {"name": "facategory", "label": "Girl Child Category", "type": "select", "required": true, "options": [["GENERAL", "GENERAL"], ["OBC", "OBC"], ["SC", "SC"], ["ST", "ST"]]}, {"name": "faqualification", "label": "Girl Child Qualification", "type": "select", "required": true, "options": [["9TH", "upto 9th Class passed"], ["10TH", "10th Class passed"], ["GRADUATE", "Graduate (Gen.)"], ["PGRADUATE", "Post Graduate(Gen.)"], ["MEDGRADUATE", "Med. Graduate/Post Graduate"], ["ENGGRADUATE", "Eng. Graduate/Post Graduate"], ["LAWGRADUATE", "Law Graduate/Post Graduate"], ["CA", "CA/ICWA/MBA/CFA"], ["COMPUTER", "Computer Degree/Diploma/MCA"], ["OPROFFESIONAL", "Other Professional Degree/Diploma"], ["ILLITERATE", "Illiterate"]]}, {"name": "faoccupation", "label": "Girl Child Occupation", "type": "select", "required": true, "options": [["STATE_GOVT", "State Govt."], ["CENTRAL_GOVT", "Central Govt."], ["PUBLIC_SECTOR_U", "Public Sector Undertaking"], ["DEFENCE", "Defence"], ["PRIVATE_SECTOR", "Private Sector"], ["INDUSTRIALIST", "Industrialist"], ["TRADE_SECTOR", "Trade Sector"], ["SERVICE_SECTOR", "Service Sector"], ["MIGRANT_LABOUR", "Migrant Labour"], ["CONTRACTOR", "Contractor"], ["JEWELLER", "Jeweller / Bullion Trader"], ["PAWN_SHOP", "Pawn Shop"], ["IMPORT_EXPORT", "Import / Export Customer"], ["OTHER_SELF_EMPLOYER", "Other Self Employed"], ["MEDICAL_PROFFESIONAL", "Medical Professional"], ["LEGAL_PROFEESIONAL", "Legal Professional"], ["CA_ICWA", "CA/ICWA/Taxation/Finance"], ["ENGINEER", "Engineer/Architect/Technical Consultant"], ["RETIRED", "Retired"], ["JOURNALIST", "Journalist"], ["HOUSEWIFE", "Housewife"], ["STUDENT", "Student"], ["SHARE", "Share and Stock Broker"], ["OTHER_PROFFESIONAL", "Other Professional"], ["AGRICULTURE", "Agriculture"], ["POLITICAL", "Political / Social Worker"], ["NOT_CATEGORISED", "Not categorised"]]}];
const parentPersonalFields = [{"name": "sacifno", "label": "Parent CIF Number", "type": "text", "required": false, "maxLength": 11, "numeric": true}, {"name": "saacno", "label": "Parent Account Number", "type": "text", "required": false, "maxLength": 11, "numeric": true}, {"name": "saname", "label": "Parent Name", "type": "text", "required": true, "maxLength": 36, "alphaOnly": true}, {"name": "sadob", "label": "Parent Date of Birth", "type": "date", "required": true}, {"name": "sagender", "label": "Parent Gender", "type": "select", "required": true, "options": [["MALE", "MALE"], ["FEMALE", "FEMALE"]]}, {"name": "samstatus", "label": "Parent Marital Status", "type": "select", "required": true, "options": [["MARRIED", "MARRIED"], ["UNMARRIED", "UNMARRIED"]]}, {"name": "saaadhaarno", "label": "Parent Aadhaar Number", "type": "text", "required": true, "maxLength": 12, "numeric": true}, {"name": "sapan", "label": "Parent PAN Number", "type": "text", "required": false, "maxLength": 10, "uppercase": true}, {"name": "safname", "label": "Parent Father's Name", "type": "text", "required": true, "maxLength": 36, "alphaOnly": true}, {"name": "sagname", "label": "Parent Guardian Name", "type": "text", "required": true, "maxLength": 36, "alphaOnly": true}, {"name": "sagrelation", "label": "Parent Guardian Relation", "type": "select", "required": true, "options": [["FATHER", "FATHER"], ["MOTHER", "MOTHER"], ["HUSBAND", "HUSBAND"], ["WIFE", "WIFE"], ["SON", "SON"], ["DAUGHTER", "DAUGHTER"], ["BROTHER", "BROTHER"], ["SISTER", "SISTER"], ["OTHER", "OTHER"]]}];
const parentAddressFields = [{"name": "saadd1", "label": "Parent Address Line 1", "type": "text", "required": true, "maxLength": 36}, {"name": "saadd2", "label": "Parent Address Line 2", "type": "text", "required": true, "maxLength": 36}, {"name": "sacity", "label": "Parent City", "type": "text", "required": true, "maxLength": 13}, {"name": "sadist", "label": "Parent District", "type": "text", "required": true, "maxLength": 23}, {"name": "sastate", "label": "Parent State", "type": "text", "required": true, "maxLength": 13}, {"name": "sapin", "label": "Parent PIN", "type": "text", "required": true, "maxLength": 6, "numeric": true}, {"name": "sabplace", "label": "Parent Birth Place", "type": "text", "required": true, "maxLength": 13}, {"name": "samobile", "label": "Parent Mobile", "type": "text", "required": true, "maxLength": 15, "numeric": true}, {"name": "saincome", "label": "Parent Income", "type": "text", "required": true, "maxLength": 8, "numeric": true}, {"name": "sareligion", "label": "Parent Religion", "type": "select", "required": true, "options": [["HINDU", "HINDU"], ["MUSLIM", "MUSLIM"], ["CHRISTIAN", "CHRISTIAN"], ["SIKH", "SIKH"]]}, {"name": "sacategory", "label": "Parent Category", "type": "select", "required": true, "options": [["GENERAL", "GENERAL"], ["OBC", "OBC"], ["SC", "SC"], ["ST", "ST"]]}, {"name": "saqualification", "label": "Parent Qualification", "type": "select", "required": true, "options": [["9TH", "upto 9th Class passed"], ["10TH", "10th Class passed"], ["GRADUATE", "Graduate (Gen.)"], ["PGRADUATE", "Post Graduate(Gen.)"], ["MEDGRADUATE", "Med. Graduate/Post Graduate"], ["ENGGRADUATE", "Eng. Graduate/Post Graduate"], ["LAWGRADUATE", "Law Graduate/Post Graduate"], ["CA", "CA/ICWA/MBA/CFA"], ["COMPUTER", "Computer Degree/Diploma/MCA"], ["OPROFFESIONAL", "Other Professional Degree/Diploma"], ["ILLITERATE", "Illiterate"]]}, {"name": "saoccupation", "label": "Parent Occupation", "type": "select", "required": true, "options": [["STATE_GOVT", "State Govt."], ["CENTRAL_GOVT", "Central Govt."], ["PUBLIC_SECTOR_U", "Public Sector Undertaking"], ["DEFENCE", "Defence"], ["PRIVATE_SECTOR", "Private Sector"], ["INDUSTRIALIST", "Industrialist"], ["TRADE_SECTOR", "Trade Sector"], ["SERVICE_SECTOR", "Service Sector"], ["MIGRANT_LABOUR", "Migrant Labour"], ["CONTRACTOR", "Contractor"], ["JEWELLER", "Jeweller / Bullion Trader"], ["PAWN_SHOP", "Pawn Shop"], ["IMPORT_EXPORT", "Import / Export Customer"], ["OTHER_SELF_EMPLOYER", "Other Self Employed"], ["MEDICAL_PROFFESIONAL", "Medical Professional"], ["LEGAL_PROFEESIONAL", "Legal Professional"], ["CA_ICWA", "CA/ICWA/Taxation/Finance"], ["ENGINEER", "Engineer/Architect/Technical Consultant"], ["RETIRED", "Retired"], ["JOURNALIST", "Journalist"], ["HOUSEWIFE", "Housewife"], ["STUDENT", "Student"], ["SHARE", "Share and Stock Broker"], ["OTHER_PROFFESIONAL", "Other Professional"], ["AGRICULTURE", "Agriculture"], ["POLITICAL", "Political / Social Worker"], ["NOT_CATEGORISED", "Not categorised"]]}];

const groups = [girlPersonalFields, girlAddressFields, parentPersonalFields, parentAddressFields];
const tabs = ["Girl Child Details", "Girl Child Address", "Parent Details", "Parent Address", "Preview"];
const allFields = groups.flat();
const initialFormData = Object.fromEntries(allFields.map((field) => [field.name, field.type === "select" ? SELECT : ""]));

function getAge(value) {
  if (!value) return null;
  const dob = new Date(`${value}T00:00:00`);
  if (Number.isNaN(dob.getTime())) return null;
  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const month = today.getMonth() - dob.getMonth();
  if (month < 0 || (month === 0 && today.getDate() < dob.getDate())) age -= 1;
  return age;
}

function formatDate(value) {
  if (!value) return "-";
  const [year, month, day] = value.split("-");
  return year && month && day ? `${day}/${month}/${year}` : value;
}

function getOptionLabel(field, value) {
  if (!field.options || !value || value === SELECT) return "-";
  return field.options.find(([optionValue]) => optionValue === value)?.[1] || value;
}

async function readJson(response) {
  const text = await response.text();
  if (!text.trim()) return null;
  try {
    return JSON.parse(text);
  } catch {
    throw new Error("The server returned invalid JSON.");
  }
}

export default function Sukanya() {
  const [currentTab, setCurrentTab] = useState(0);
  const [maxAllowedTab, setMaxAllowedTab] = useState(0);
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const [sameAddress, setSameAddress] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [showPdf, setShowPdf] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [pdfError, setPdfError] = useState("");
  const nextButtonRef = useRef(null);

  const girlAge = useMemo(() => getAge(formData.fadob), [formData.fadob]);
  const parentAge = useMemo(() => getAge(formData.sadob), [formData.sadob]);
  const parentIsMinor = parentAge !== null && parentAge < 18;
  const currentFields = currentTab < 4 ? groups[currentTab] : [];

  const isDisabled = (field) =>
    ["sagname", "sagrelation"].includes(field.name) && !parentIsMinor;

  const enabledFields = currentFields.filter((field) => !isDisabled(field));

  useEffect(() => {
    const first = enabledFields[0];
    if (!first) return undefined;
    const frame = requestAnimationFrame(() => document.getElementById(first.name)?.focus());
    return () => cancelAnimationFrame(frame);
  }, [currentTab, parentIsMinor]);

  useEffect(() => {
    if (!parentIsMinor) {
      setFormData((previous) => ({ ...previous, sagname: "", sagrelation: SELECT }));
      setErrors((previous) => ({ ...previous, sagname: "", sagrelation: "" }));
    }
  }, [parentIsMinor]);

  useEffect(() => {
    if (!sameAddress) return;
    setFormData((previous) => ({
      ...previous,
      saadd1: previous.faadd1,
      saadd2: previous.faadd2,
      sacity: previous.facity,
      sadist: previous.fadist,
      sastate: previous.fastate,
      sapin: previous.fapin,
      sabplace: previous.fabplace,
    }));
  }, [sameAddress, formData.faadd1, formData.faadd2, formData.facity, formData.fadist, formData.fastate, formData.fapin, formData.fabplace]);

  useEffect(() => {
    const controller = new AbortController();
    (async () => {
      try {
        const response = await fetch(`/backend/api/autofill.php?form=${encodeURIComponent(FORM_NAME)}`, {
          credentials: "include",
          cache: "no-store",
          headers: { Accept: "application/json" },
          signal: controller.signal,
        });
        const result = await readJson(response);
        if (!response.ok || !result?.success || !result?.found || !result?.data) return;
        setFormData((previous) => ({
          ...previous,
          facity: previous.facity || result.data.city || "",
          fadist: previous.fadist || result.data.dist || "",
          fastate: previous.fastate || result.data.state || "",
          fapin: previous.fapin || result.data.pin || "",
        }));
      } catch (error) {
        if (error.name !== "AbortError") console.error("SBISSA3 autofill error:", error);
      }
    })();
    return () => controller.abort();
  }, []);

  useEffect(() => () => {
    if (pdfUrl?.startsWith("blob:")) URL.revokeObjectURL(pdfUrl);
  }, [pdfUrl]);

  const updateField = (field, rawValue) => {
    let value = rawValue;
    if (field.numeric) value = value.replace(/\D/g, "");
    if (field.alphaOnly) value = value.replace(/[^A-Za-z ]/g, "");
    if (field.uppercase || field.name.includes("pan")) value = value.toUpperCase();
    setFormData((previous) => ({ ...previous, [field.name]: value }));
    setErrors((previous) => ({ ...previous, [field.name]: "" }));
  };

  const validateField = (field) => {
    if (isDisabled(field)) return "";
    const value = String(formData[field.name] ?? "").trim();

    if (field.required && (field.type === "select" ? !value || value === SELECT : !value)) {
      return `${field.label} is required.`;
    }
    if (field.alphaOnly && value && !/^[A-Za-z ]+$/.test(value)) return `${field.label} must contain alphabet letters only.`;
    if (["faaadhaarno", "saaadhaarno"].includes(field.name) && value && !/^\d{12}$/.test(value)) return "Aadhaar number must contain exactly 12 digits.";
    if (["sacifno", "saacno"].includes(field.name) && value && !/^\d{11}$/.test(value)) return `${field.label} must contain 11 digits.`;
    if (["fapin", "sapin"].includes(field.name) && value && !/^\d{6}$/.test(value)) return "PIN must contain exactly 6 digits.";
    if (["famobile", "samobile"].includes(field.name) && value && !/^\d{10}$/.test(value)) return "Mobile number must contain 10 digits.";
    if (["fapan", "sapan"].includes(field.name) && value && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(value)) return "Enter a valid PAN number (e.g. ABCDE1234F).";
    if (field.name === "fadob" && girlAge !== null && girlAge > 10) return "Girl child age must not exceed 10 years.";
    return "";
  };

  const validateFields = (fields) => {
    const nextErrors = {};
    fields.forEach((field) => {
      const message = validateField(field);
      if (message) nextErrors[field.name] = message;
    });
    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const goNext = () => {
    if (!validateFields(currentFields)) return;
    const next = currentTab + 1;
    setCurrentTab(next);
    setMaxAllowedTab((previous) => Math.max(previous, next));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const goPrevious = () => {
    setCurrentTab((previous) => Math.max(0, previous - 1));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleLastFieldKeyDown = (event, fieldName) => {
    const lastName = enabledFields[enabledFields.length - 1]?.name;
    if (fieldName === lastName && event.key === "Tab" && !event.shiftKey) {
      event.preventDefault();
      nextButtonRef.current?.focus();
    }
  };

  // Open in PdfViewerContainer

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateFields(allFields)) {
      const firstInvalid = allFields.find((field) => validateField(field));
      const invalidTab = groups.findIndex((group) => group.some((field) => field.name === firstInvalid?.name));
      setCurrentTab(Math.max(0, invalidTab));
      return;
    }

    setPdfLoading(true);
    setPdfError("");

    try {
      const body = new FormData();
      Object.entries(formData).forEach(([name, value]) => {
        body.append(name, value === SELECT ? "" : String(value ?? ""));
      });

      const controller = new AbortController();
      const timeoutId = window.setTimeout(() => controller.abort(), 60000);
      let response;

      try {
        response = await fetch(PDF_ENDPOINT, {
          method: "POST",
          body,
          credentials: "include",
          headers: { Accept: "application/pdf" },
          signal: controller.signal,
        });
      } finally {
        window.clearTimeout(timeoutId);
      }

      if (!response.ok) throw new Error((await response.text()) || `PDF generation failed (${response.status}).`);

      const contentType = response.headers.get("content-type") || "";
      if (!contentType.includes("application/pdf")) {
        throw new Error((await response.text()) || "Print.php did not return a PDF file.");
      }

      const objectUrl = URL.createObjectURL(await response.blob());
      setPdfUrl((previous) => {
        if (previous?.startsWith("blob:")) URL.revokeObjectURL(previous);
        return objectUrl;
      });
      setShowPdf(true);
    } catch (error) {
      setPdfError(error.name === "AbortError" ? "PDF generation timed out." : error.message || "Unable to generate PDF preview.");
    } finally {
      setPdfLoading(false);
    }
  };


  // // Open in New Tab

  //   const handleSubmit = (event) => {
  //   event.preventDefault();

  //   if (!validateFields(allFields)) {
  //     const firstInvalid = allFields.find((field) => validateField(field));
  //     const invalidTab = groups.findIndex((group) =>
  //       group.some((field) => field.name === firstInvalid?.name)
  //     );
  //     setCurrentTab(Math.max(0, invalidTab));
  //     return;
  //   }

  //   setPdfLoading(true);
  //   setPdfError("");

  //   try {
  //     const printForm = document.createElement("form");

  //     printForm.method = "POST";
  //     printForm.action = PDF_ENDPOINT;
  //     printForm.target = "_blank";
  //     printForm.style.display = "none";

  //     Object.entries(formData).forEach(([name, value]) => {
  //       const input = document.createElement("input");
  //       input.type = "hidden";
  //       input.name = name;
  //       input.value = value === SELECT ? "" : String(value ?? "");
  //       printForm.appendChild(input);
  //     });

  //     document.body.appendChild(printForm);
  //     printForm.submit();
  //     printForm.remove();
  //   } catch (error) {
  //     setPdfError(
  //       error instanceof Error
  //         ? error.message
  //         : "Unable to open PDF."
  //     );
  //   } finally {
  //     setPdfLoading(false);
  //   }
  // };

  const renderField = (field) => {
    const error = errors[field.name];
    const disabled = isDisabled(field);

    return (
      <div key={field.name} className="space-y-2">
        <Label htmlFor={field.name}>
          {field.label}{field.required && !disabled && <span className="text-red-500"> *</span>}
        </Label>

        {field.type === "select" ? (
          <select
            id={field.name}
            name={field.name}
            value={formData[field.name]}
            disabled={disabled}
            onChange={(event) => updateField(field, event.target.value)}
            onKeyDown={(event) => handleLastFieldKeyDown(event, field.name)}
            className={`flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm disabled:cursor-not-allowed disabled:opacity-50 ${error ? "border-red-500" : ""}`}
          >
            <option value={SELECT}>SELECT</option>
            {field.options.map(([value, label]) => (
              <option key={`${field.name}-${value}`} value={value}>{label}</option>
            ))}
          </select>
        ) : (
          <Input
            id={field.name}
            name={field.name}
            type={field.type || "text"}
            value={formData[field.name]}
            maxLength={field.maxLength}
            disabled={disabled}
            placeholder={field.label}
            className={error ? "border-red-500" : ""}
            onChange={(event) => updateField(field, event.target.value)}
            onKeyDown={(event) => handleLastFieldKeyDown(event, field.name)}
          />
        )}

        {field.name === "fadob" && girlAge !== null && <p className="text-sm text-muted-foreground">Girl child age: {girlAge} years</p>}
        {field.name === "sadob" && parentAge !== null && <p className="text-sm text-muted-foreground">Parent age: {parentAge} years{parentIsMinor ? " — Guardian details required." : ""}</p>}
        {error && <p className="text-sm text-red-500">{error}</p>}
      </div>
    );
  };

  if (showPdf && pdfUrl) {
    return <PdfViewerContainer pdfUrl={pdfUrl} title="SBI Sukanya Samriddhi Account Opening Form" onBack={() => setShowPdf(false)} />;
  }

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="mx-auto max-w-7xl">
        <Card className="mb-6">
          <CardHeader>
            <CardTitle className="text-3xl">🏦 SBI Sukanya Samriddhi Account Opening Form</CardTitle>
            <p className="text-muted-foreground">Enter the girl child and parent details carefully.</p>
          </CardHeader>
        </Card>

        <div className="mb-8 grid grid-cols-2 gap-3 md:grid-cols-5">
          {tabs.map((tab, index) => (
            <Button key={tab} type="button" variant={currentTab === index ? "default" : "outline"} disabled={index > maxAllowedTab} onClick={() => setCurrentTab(index)}>
              {index + 1}. {tab}
            </Button>
          ))}
        </div>

        {currentTab < 4 ? (
          <Card>
            <CardHeader><CardTitle>{tabs[currentTab]}</CardTitle></CardHeader>
            <CardContent>
              {currentTab === 3 && (
                <label className="mb-6 flex items-center gap-3 rounded-lg border p-3">
                  <input type="checkbox" checked={sameAddress} onChange={(event) => setSameAddress(event.target.checked)} className="h-5 w-5" />
                  <span>Parent address is same as girl child address</span>
                </label>
              )}
              <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
                {currentFields.map(renderField)}
              </div>
            </CardContent>
          </Card>
        ) : (
          <Card>
            <CardHeader><CardTitle>📋 Preview</CardTitle></CardHeader>
            <CardContent className="space-y-8">
              {[
                ["Girl Child Personal Details", girlPersonalFields],
                ["Girl Child Address Details", girlAddressFields],
                ["Parent Personal Details", parentPersonalFields],
                ["Parent Address Details", parentAddressFields],
              ].map(([title, fields]) => (
                <section key={title}>
                  <h3 className="mb-3 text-lg font-semibold">{title}</h3>
                  <div className="overflow-hidden rounded-lg border">
                    {fields.map((field) => (
                      <div key={field.name} className="grid grid-cols-2 border-b p-3 last:border-b-0">
                        <span className="font-medium">{field.label}</span>
                        <span className="break-words">
                          {field.type === "date" ? formatDate(formData[field.name]) : field.type === "select" ? getOptionLabel(field, formData[field.name]) : formData[field.name] || "-"}
                        </span>
                      </div>
                    ))}
                  </div>
                </section>
              ))}
            </CardContent>
          </Card>
        )}

        {pdfError && <p className="mt-4 rounded-lg border border-red-300 bg-red-50 p-3 text-red-700">{pdfError}</p>}

        <div className="mt-6 flex items-center justify-between">
          <Button type="button" variant="outline" onClick={goPrevious} disabled={currentTab === 0}>← Previous</Button>
          {currentTab === 4 ? (
            <Button type="button" ref={nextButtonRef} onClick={handleSubmit} disabled={pdfLoading}>
              {pdfLoading ? "Generating PDF..." : "Submit & Preview PDF"}
            </Button>
          ) : (
            <Button type="button" ref={nextButtonRef} onClick={goNext}>
              {currentTab === 3 ? "Preview" : "Next →"}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
